import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "material-icons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiloxeniaIcon = _resolveComponent("FiloxeniaIcon")!

  return (_ctx.lib === 'bi' || _ctx.lib === 'fa-solid')
    ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass(`${_ctx.lib} ${_ctx.icon}`)
      }, null, 2))
    : (_ctx.lib === 'fa')
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(`${_ctx.lib}-solid ${_ctx.icon}`)
        }, null, 2))
      : (_ctx.lib === 'material')
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.icon), 1))
        : (_ctx.lib === 'filoxenia')
          ? (_openBlock(), _createBlock(_component_FiloxeniaIcon, {
              key: 3,
              name: _ctx.icon
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
}